import React, {useEffect, useRef, useState} from "react";
import {
    DialogSize,
    RaikoBaseCardContainer,
    RaikoBaseContainer, RaikoButtonPrimary, RaikoButtonSecondary,
    RaikoCardInfoTypeOne, RaikoCardInfoTypeOneItemGenerator, RaikoChipSizeType,
    RaikoChipTypes,
    RaikoCustomSimpleChip,
    RaikoCustomTable,
    RaikoDefaultDialogPage,
    RaikoGridOneColumn,
    RaikoGridTwoColumn,
    RaikoSearchInputOutlined,
    RaikoSectionContainer,
    RaikoTableSearchContainer,
    RaikoTableTitleContainer,
    showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import {PeriodService} from "../../../serverService/periodService/PeriodService";
import {useDebounce} from "@uidotdev/usehooks";
import ResidenceChoiceInformation from "./ResidenceChoiceInformation";
import ResidenceChoiceAdd from "./ResidenceChoiceAdd";
import {Link, useLocation, useNavigate, useSearchParams} from "react-router-dom";
import TableOtherAccessContainer
    from "../../../component/tableCreateHelper/tableOtherAccessContainer/TableOtherAccessContainer";
import {RouteHelper} from "../../../route/RouteHelper";

export default function ResidenceChoice({periodId}) {

    const [searchParams, setSearchParams] = useSearchParams();
    // const location = useLocation();
    // const [currentPath, setCurrentPath] = useState(location.pathname)
    // const [currentSearch, setCurrentSearch] = useState(location.search)
    // console.log("currentPath:", currentPath);
    // console.log("currentSearch:", currentSearch);
    //
    // useEffect(() => {
    //     getPath();
    //     // console.log("currentPath:", location.pathname);
    //     // console.log("currentSearch:", location.search);
    // }, [currentPath, currentSearch]);
    //
    // const prevPath = useRef(currentPath + currentSearch);
    // const current = currentPath + currentSearch;
    //
    // function getPath() {
    //     if (current !== prevPath.current) {
    //         setCurrentPath(location.pathname)
    //         setCurrentSearch(location.search)
    //         console.log("currentPath:", currentPath);
    //         console.log("currentSearch:", currentSearch);
    //         prevPath.current = current;
    //     }
    // }

    const [page, setPage] = useState(0)

    let size = 15

    const service = new PeriodService()


    const [totalResidence, setTotalResidence] = useState("")

    const [title, setTitle] = useState(searchParams.get("title") || "");
    const filterTitle = useDebounce(title, 500)

    useEffect(() => {
        if (typeof service !== "undefined") {
            getDataFromServer()
            checkingFiltersAndSearches()
        }
    }, [
        filterTitle,
        page,
    ]);

    function getDataFromServer() {
        setIsLoading(true)

        service.getHostsList(
            periodId,
            page,
            size,
            filterTitle
        ).then(response => {
            setPageCount(response.totalPage)
            setResidenceChoiceList([])
            setTotalResidence(response.numberOfItems)

            setTotalItems(response.numberOfItems)

            response.data.map((item, index) => {
                setResidenceChoiceList(prevState => [
                    ...prevState,
                    residenceChoiceRow(
                        (page * size) + index + 1,
                        item.id,
                        item.priority,
                        item.residence.metaData.title,
                        item.clerk && item.clerk.metaData ? item.clerk.metaData.fullName : "-",
                        item.clerk && item.clerk.phoneNumber ? item.clerk.phoneNumber : "-",
                        item.menCapacity,
                        item.womenCapacity,
                        item.activeForAcceptation,
                        item.activeForAutomaticAcceptance,
                        item.clerk && item.clerk.id ? item.clerk.id : 0,
                        "حذف"
                    )
                ])
            })

            setIsLoading(false)
        }).catch(reason => {
            showServerErrorMessage(reason)
            setIsLoading(false)
        })
    }


    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [deleteItemId, setDeleteItemId] = useState(-1);

    function handleOpenDeleteDialog(id) {
        setDeleteItemId(id)
        setOpenDeleteDialog(true)
    }

    function handleCloseDeleteDialog() {
        setOpenDeleteDialog(false)
    }

    function doDeleteItem() {

    }


    //start preparing the table
    const [pageCount, setPageCount] = useState(0);
    const [isLoading, setIsLoading] = useState(false)
    const [residenceChoiceList, setResidenceChoiceList] = useState([])
    const [totalItems, setTotalItems] = useState(0);

    function residenceChoiceRow(
        number,
        id,
        priority,
        title,
        servant,
        phoneNumber,
        menNumber,
        womenNumber,
        acceptanceStatus,
        automaticCheck,
        servantId,
        acceptanceStatusCardType,
        automaticCheckCardType,
        residenceDelete) {
        return {
            number,
            id,
            priority,
            title,
            servant,
            phoneNumber: phoneNumber,
            menNumber,
            womenNumber,
            acceptanceStatus: acceptanceStatus ? <RaikoCustomSimpleChip title={"فعال"} type={RaikoChipTypes.success}/> :
                <RaikoCustomSimpleChip title={"غیر فعال"} type={RaikoChipTypes.error}/>,
            automaticCheck: automaticCheck ? <RaikoCustomSimpleChip title={"فعال"} type={RaikoChipTypes.success}/> :
                <RaikoCustomSimpleChip title={"غیر فعال"} type={RaikoChipTypes.error}/>,
            servantInfo: <TableOtherAccessContainer>
                <Link
                    to={RouteHelper.ResidencesManagerInfo.globalUrl.replace(":id", servantId)}
                    target={"_blank"}
                >
                    <div className={"ic-profile"} onClick={event => {
                        event.stopPropagation();
                        event.preventDefault();
                        window.open(RouteHelper.ResidencesManagerInfo.globalUrl.replace(":id", servantId) + `?title=${encodeURIComponent(servant)}`, "_blank")
                    }}/>
                </Link>
            </TableOtherAccessContainer>,
            residenceDelete: <button onClick={_ => {
                handleOpenDeleteDialog(id)
            }} className={`btnAccess delete-icon ${css`
                &:hover {
                    background-color: var(--color-primary);
                }

            `}`}/>,
            servantId,
            acceptanceStatusCardType: automaticCheck ?
                <RaikoCustomSimpleChip size={RaikoChipSizeType.small} title={"فعال"} type={RaikoChipTypes.success}/> :
                <RaikoCustomSimpleChip size={RaikoChipSizeType.small} title={"غیر فعال"} type={RaikoChipTypes.error}/>,
            automaticCheckCardType: automaticCheck ?
                <RaikoCustomSimpleChip size={RaikoChipSizeType.small} title={"فعال"} type={RaikoChipTypes.success}/> :
                <RaikoCustomSimpleChip size={RaikoChipSizeType.small} title={"غیر فعال"} type={RaikoChipTypes.error}/>,
        }

    }

    function handlePagination(newPage) {
        setPage(newPage)
        // getDataFromServer()
    }

    //end preparing the table


    //modal-info-start
    const [openDialogInfo, setOpenDialogInfo] = useState(false)

    function handleCloseDialogInfo() {
        setOpenDialogInfo(false)
        setResidenceId(-1)
        getDataFromServer()
    }

    const [residenceId, setResidenceId] = useState(-1);

    function handleOpenDialogInfo() {
        setOpenDialogInfo(true)
    }

    function handleUpdateResidenceInfo(residenceId) {
        setResidenceId(residenceId)
        handleOpenDialogInfo()
    }

    //modal-info-end


    //modal-info-start
    const [openDialogAdd, setOpenDialogAdd] = useState(false)

    function handleCloseDialogAdd() {
        setOpenDialogAdd(false)
        getDataFromServer()
    }

    function handleOpenDialogAdd() {
        setOpenDialogAdd(true)
    }

    //modal-info-end

    const navigate = useNavigate()

    const location = useLocation();
    const [currentPath, setCurrentPath] = useState(location.pathname)
    const [currentSearch, setCurrentSearch] = useState(location.search)

    function checkingFiltersAndSearches() {
        const filters = []

        if (typeof page !== 'undefined' && parseInt(page) > 0) {
            filters.push(`page=${parseInt(page) + 1}`)
        }
        if (title && title.length > 0) {
            filters.push(`title=${title}`)
        }
        let filterItems = ""
        if (filters && filters.length > 0) {
            filters.map((item, index) => {
                if (index === 0)
                    filterItems = item
                else
                    filterItems = filterItems + `&${item}`
            })
        }


        navigate(`${currentPath}${currentSearch}?${filterItems}`)
    }

    const [selectDisplayType, setSelectDisplayType] = useState(false)
    return (
        <>
            <RaikoDefaultDialogPage
                pageTitle={""}
                dialogSize={DialogSize.WRAP_CONTENT}
                onClose={handleCloseDialogInfo}
                open={openDialogInfo}
            >
                <ResidenceChoiceInformation handleCloseDialogInfo={handleCloseDialogInfo} residenceId={residenceId}/>
            </RaikoDefaultDialogPage>
            <RaikoDefaultDialogPage
                pageTitle={""}
                dialogSize={DialogSize.LARGE}
                onClose={handleCloseDialogAdd}
                open={openDialogAdd}>
                <ResidenceChoiceAdd periodId={periodId} handleCloseDialogAdd={handleCloseDialogAdd}/>
            </RaikoDefaultDialogPage>
            <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        <RaikoTableTitleContainer
                            title={"اقامتگاه ها"}
                            amount={totalResidence}
                            hasCreateNewItem
                            handleCreateNewItem={handleOpenDialogAdd}
                            hasSelectDisplayType
                            selectDisplayType={selectDisplayType}
                            setSelectDisplayType={setSelectDisplayType}
                        />
                        <RaikoTableSearchContainer
                            labelText={"عنوان اقامتگاه"}
                            value={title}
                            setValue={setTitle}
                        />
                        <RaikoCustomTable
                            pageCount={pageCount}
                            handlePaginationChange={handlePagination}
                            isLoading={isLoading}
                            data={residenceChoiceList}
                            header={residenceChoiceTableHeader}
                            rowClicked={handleUpdateResidenceInfo}
                            selectDisplayType={selectDisplayType}
                        >
                            <RaikoGridTwoColumn className={css`padding: 3px`}>
                                {
                                    residenceChoiceList.map((item, index) => {
                                        return <RaikoCardInfoTypeOne
                                            key={index}
                                            iconClass={"ic_residence"}
                                            title={item.title}
                                            titleLabel={item.servant}
                                            items={[
                                                RaikoCardInfoTypeOneItemGenerator("اولویت", item.priority),
                                                RaikoCardInfoTypeOneItemGenerator("شماره تماس", item.phoneNumber),
                                                RaikoCardInfoTypeOneItemGenerator("تعداد آقا", item.menNumber),
                                                RaikoCardInfoTypeOneItemGenerator("تعداد خانم", item.womenNumber),
                                                RaikoCardInfoTypeOneItemGenerator("وضعیت پذیرش", item.acceptanceStatusCardType),
                                                RaikoCardInfoTypeOneItemGenerator("بررسی خودکار", item.automaticCheckCardType),
                                            ]}
                                            hasBottomChildren
                                        >
                                            <div className={css`display: flex;
                                                gap: 1rem;
                                                align-items: center;
                                                justify-content: end`}>
                                                <RaikoButtonSecondary
                                                    label={"اطلاعات خادم"}
                                                    onClick={event => {
                                                        event.stopPropagation();
                                                        event.preventDefault();
                                                        window.open(RouteHelper.ResidencesManagerInfo.globalUrl.replace(":id", item.servantId) + `?title=${encodeURIComponent(item.servant)}`, "_blank")
                                                    }}
                                                />
                                                {/*<Link*/}
                                                {/*    to={RouteHelper.ResidencesManagerInfo.globalUrl.replace(":id", item.servantId)}*/}
                                                {/*    target={"_blank"}*/}
                                                {/*>*/}
                                                {/*    <div className={"ic-profile"} onClick={event => {*/}
                                                {/*        event.stopPropagation();*/}
                                                {/*        event.preventDefault();*/}
                                                {/*        window.open(RouteHelper.ResidencesManagerInfo.globalUrl.replace(":id", item.servantId) + `?title=${encodeURIComponent(item.servant)}`, "_blank")*/}
                                                {/*    }}/>*/}
                                                {/*</Link>*/}
                                                <RaikoButtonSecondary
                                                    label={"جزئیات اقامتگاه"}
                                                    onClick={_=>{
                                                        handleUpdateResidenceInfo(item.id)
                                                    }}
                                                />
                                            </div>
                                        </RaikoCardInfoTypeOne>
                                    })
                                }

                            </RaikoGridTwoColumn>

                        </RaikoCustomTable>
                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>
            </RaikoGridOneColumn>
        </>
    )
}
const residenceChoiceTableHeader = [
    {
        id: "number",
        label: "#"
    },
    {
        id: "priority",
        label: "اولویت"
    },
    {
        id: "title",
        label: "عنوان",
    },
    {
        id: "servant",
        label: "خادم",
    },
    {
        id: "phoneNumber",
        label: "شماره تماس"
    },
    {
        id: "menNumber",
        label: "تعداد آقا",
    },
    {
        id: "womenNumber",
        label: "تعداد خانم",
    },
    {
        id: "acceptanceStatus",
        label: "وضعیت پذیرش",
    },
    {
        id: "automaticCheck",
        label: "بررسی خودکار"
    },
    {
        id: "servantInfo",
        label: "اطلاعات خادم"
    },

]